export interface ApiResponse<T> {
  success: boolean;
  error?: string;
  message?: string;
  data?: T;
}

// Custom error class for API errors
export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public response?: unknown,
    public code?: string
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

/**
 * Reads a failed fetch Response's JSON `error` field and throws an ApiError.
 * Falls back to `${fallbackPrefix}: ${statusText}` when the body is missing,
 * not JSON, or carries no error message. Only call when `response.ok` is false.
 */
export async function throwApiError(
  response: Response,
  fallbackPrefix: string
): Promise<never> {
  let message = `${fallbackPrefix}: ${response.statusText}`;
  try {
    const body = await response.json();
    if (body.error) message = body.error;
    throw new ApiError(message, response.status, body, body.code);
  } catch (err) {
    if (err instanceof ApiError) throw err;
    // body wasn't JSON — keep the fallback message
  }
  throw new ApiError(message, response.status);
}
